<template>
  <div class="item-description-image-area">
    <img
      v-if="imageUrl"
      :src="imageUrl"
      :alt="caption || ''"
      class="item-description-image"
    />
    <p v-if="caption" class="item-description-image-caption">
      {{ caption }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ItemDescriptionImage',
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    caption: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.item-description-image-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.item-description-image {
  width: 100%;
  max-height: 500px;
  height: auto;
  object-fit: contain;
}

.item-description-image-caption {
  @extend %caption;
  width: 100%;
  text-align: left;
}
</style>
